export default __webpack_public_path__ + "static/media/completed_male@2x.5d99f1b9.png";